import React from "react";
//#region types
import { SelectInputItemProps, NumberInputWithSuggestionsProps } from "models/propTypes/wintFormPropsTypes";
//#endregion
//#region components
import { Autocomplete } from "@mui/material";
import BaseNumberInput from "./baseNumberInput";
import useAutoCompleteCommonProps from "./useAutoCompleteCommonProps";
//#endregion

const NumberInputWithSuggestions: React.FC<NumberInputWithSuggestionsProps> = (props) => {
  const options = props.suggestions ?? [];

  const [open, setOpen] = React.useState<boolean>(false);
  const [focused, setFocused] = React.useState<boolean>(false);

  const onChange = (event: any, newValue: SelectInputItemProps | string | null) => {
    setOpen(false);
    setFocused(false);

    if (typeof newValue === "string" || typeof newValue === "number") {
      props.setValue(newValue, true);
    } else {
      props.setValue(newValue?.value, true);
    }
  };

  const onInputChange = (event: object, value: string, reason: string) => {
    props.setValue(value);
    if (focused) {
      setOpen(true);
    } else {
      setOpen(false);
    }
  };

  const onClose = () => {
    setOpen(false);
  };

  const onFocus = () => {
    setFocused(true);
    setOpen(true);
  };

  const onBlur = (event: React.FocusEvent<HTMLInputElement>) => {
    setFocused(false);
    setOpen(false);
    setTimeout(() => {
      props.onBlur && props.onBlur(event);
    });
  };

  const onClick = () => {
    if (focused && !open) {
      setOpen(true);
    }
  };

  const commonProps = useAutoCompleteCommonProps(props.disabled, props.hasError, props.suffix);

  return (
    <Autocomplete
      id={`autoComplete-${props.name}`}
      {...commonProps}
      freeSolo
      options={options.map((item) => ({
        value: item,
        label: item.toString(),
      }))}
      getOptionLabel={(option) => {
        return typeof option === "string" || typeof option === "number" ? option.toString() : option.label;
      }}
      loading={props.suggestions === undefined}
      value={props.value ?? null}
      open={open}
      blurOnSelect={false}
      onClose={onClose}
      onChange={onChange}
      onInputChange={onInputChange}
      disabled={props.disabled}
      renderInput={(params) => (
        <BaseNumberInput
          {...props}
          type="number"
          name={props.name}
          value={props.value}
          label={props.label}
          setValue={() => {}}
          touched={props.touched}
          setTouched={props.setTouched}
          hasError={props.hasError}
          onChange={params.inputProps.onChange ?? (() => {})}
          onBlur={onBlur}
          onFocus={onFocus}
          onClick={onClick}
          inputProps={params.inputProps}
          InputProps={params.InputProps}
          optional={props.optional}
        />
      )}
      data-testid={`${props.name}NumberInputWithSuggestions`}
    />
  );
};

export default NumberInputWithSuggestions;
